import { signal } from "@preact/signals-react"

export const onlineUsers = signal<string[]>([])
